import React from 'react'

import { useSearchParam } from '../../../../hooks'
import { Table } from './table'
import { Title } from './title'

export const EInvoiceHistory: React.FC = () => {
  const [searchParam, setSearchParam] = useSearchParam('search')

  return (
    <>
      <Title search={searchParam} setSearch={setSearchParam} />
      <Table setSearch={setSearchParam} search={searchParam} />
    </>
  )
}
